export default __webpack_public_path__ + "img/white-plus.0db31242.svg";